import { getDataGridToolbarProps } from 'features/shared/utility/dataGridToolbarHelper';
import usePermissions from 'features/shared/hooks/usePermissions';
import { PERMISSION_RESOURCES } from 'features/shared/constants/permissionResources';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Box } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { CommonDataGrid } from 'features/shared/components/table';
import { RMSButton } from '../../../shared/components/buttons';
import { executeApiAction } from '../../../shared/utility/apiHelper';
import PlaceVehicleRegistrationDialog from './PlaceVehicleRegistrationDialog';
import { getPlaceVehicleRegistrations } from '../../services/vehicleService';
import { VEHICLE_REG_GRID_COLUMNS } from '../../constants/placeVehicleRegistrationsTabConstants';
import FormSpinner from 'components/FormSpinner';

const PlaceVehicleRegistrationsTab = ({ ptsPlaceID }) => {
  const dispatch = useDispatch();
  const canEditPlace = usePermissions(PERMISSION_RESOURCES.PLACE).Edit;
  const [loading, setLoading] = useState(false);
  const [registrations, setRegistrations] = useState([]);
  const [formOpen, setFormOpen] = useState(false);
  const [editingRegistration, setEditingRegistration] = useState(null);

  const loadRegistrations = useCallback(async () => {
    if (!ptsPlaceID) return;

    await executeApiAction({
      setLoading,
      dispatch,
      action: () => getPlaceVehicleRegistrations(ptsPlaceID),
      onSuccess: (data) => setRegistrations(data),
    });
  }, [dispatch, ptsPlaceID]);

  const handleAdd = useCallback(() => {
    setEditingRegistration(null);
    setFormOpen(true);
  }, []);

  const handleEdit = useCallback((row) => {
    setEditingRegistration(row);
    setFormOpen(true);
  }, []);

  const handleFormClose = useCallback(() => {
    setFormOpen(false);
    setEditingRegistration(null);
  }, []);

  const handleSaved = useCallback(() => {
    handleFormClose();
    loadRegistrations();
  }, [handleFormClose, loadRegistrations]);

  useEffect(() => {
    loadRegistrations();
  }, [loadRegistrations]);

  return (
    <Box className="person-names-tab__grid-wrap place-grid-tab">
      {loading && <FormSpinner />}
      <Box className="person-addresses-tab__toolbar">
        <RMSButton
          label="Add Vehicle Registration"
          prefixIcon={<AddIcon />}
          onClick={handleAdd}
          disabled={!canEditPlace}
        />
      </Box>

      <CommonDataGrid
        rows={registrations}
        columns={VEHICLE_REG_GRID_COLUMNS}
        getRowId={(row) => row.ptsRegistrationID}
        toolbar={getDataGridToolbarProps({ printTitle: 'Place Vehicle Registrations' })}
        actions={{
          edit: { visible: true, onClick: handleEdit, disabled: !canEditPlace },
        }}
      />

      {formOpen && (
        <PlaceVehicleRegistrationDialog
          open={formOpen}
          ptsPlaceID={ptsPlaceID}
          registration={editingRegistration}
          onClose={handleFormClose}
          onSaved={handleSaved}
        />
      )}
    </Box>
  );
};

export default PlaceVehicleRegistrationsTab;
